import { Type, type Static } from "typebox";
import { BillingAccountViewV1Schema } from "./billing.ts";
import { ProductKeySchema } from "./identity.ts";

const InternalIdSchema = Type.String({ format: "uuid" });
const OrganizationNameSchema = Type.String({ minLength: 1, maxLength: 200 });
/**
 * Same-origin public logo paths (e.g. `/assets/logos/<key>.png`) or absolute
 * asset URLs. Must stay aligned with settings logoUrl — relative paths are the
 * Platform browser wire form and are not absolute URIs.
 */
const LogoUrlSchema = Type.Union([
  Type.String({ minLength: 1, maxLength: 512 }),
  Type.Null(),
]);

export const OverviewOrganizationV1Schema = Type.Object({
  id: InternalIdSchema,
  name: OrganizationNameSchema,
  logoUrl: LogoUrlSchema,
}, { additionalProperties: false });
export type OverviewOrganizationV1 = Static<typeof OverviewOrganizationV1Schema>;

export const OverviewProductV1Schema = Type.Object({
  key: ProductKeySchema,
  name: Type.String({ minLength: 1, maxLength: 40 }),
  description: Type.String({ minLength: 1, maxLength: 240 }),
  launchUrl: Type.String({ format: "uri", minLength: 1, maxLength: 512 }),
}, { additionalProperties: false });
export type OverviewProductV1 = Static<typeof OverviewProductV1Schema>;

export const ThirtyDayPulseV1Schema = Type.Object({
  activeMembers: Type.Integer({ minimum: 0 }),
  productSessions: Type.Integer({ minimum: 0 }),
  successRate: Type.Union([Type.Number({ minimum: 0, maximum: 1 }), Type.Null()]),
  inputTokens: Type.Integer({ minimum: 0 }),
  outputTokens: Type.Integer({ minimum: 0 }),
  cachedTokens: Type.Integer({ minimum: 0 }),
  estimatedCostMicros: Type.Union([Type.Integer({ minimum: 0 }), Type.Null()]),
}, { additionalProperties: false });
export type ThirtyDayPulseV1 = Static<typeof ThirtyDayPulseV1Schema>;

export const OverviewViewV1Schema = Type.Object({
  version: Type.Literal(1),
  organization: OverviewOrganizationV1Schema,
  account: BillingAccountViewV1Schema,
  products: Type.Array(OverviewProductV1Schema, { minItems: 4, maxItems: 4 }),
  pulse: Type.Union([ThirtyDayPulseV1Schema, Type.Null()]),
}, { additionalProperties: false });
export type OverviewViewV1 = Static<typeof OverviewViewV1Schema>;
